/*import React from 'react'
import Link from 'gatsby-link'

const FleetMenu = ({ lang }) => {
	if (lang === 'es') {
		return (
			<ul className="dropdown locations_menu_fleet">
				<li>
					<Link to="/es/fleet/standard_suv">Standard SUV</Link>
				</li>
				<li>
					<Link to="/es/fleet/compact_recreational_vehicle">Compact Recreational Vehicle</Link>
				</li>
				<li>
					<Link to="/es/fleet/mid_size_pick_up">Mid-size Pick up</Link>
				</li>
				<li>
					<Link to="/es/fleet/standard_elite_suv">Standard Elite SUV</Link>
				</li>
				<li>
					<Link to="/es/fleet/premium">Premium</Link>
				</li>
				<li>
					<Link to="/es/fleet/luxury">Luxury</Link>
				</li>
				<li>
					<Link to="/es/fleet/standard_sport">Standard Sport</Link>
				</li>
				<li>
					<Link to="/es/fleet/premium_elite">Premium Elite</Link>
				</li>

				<li>
					<Link to="/es/fleet/economic">Económico</Link>
				</li>
				<li>
					<Link to="/es/fleet/compact">Compacto</Link>
				</li>
				<li>
					<Link to="/es/fleet/economic_4x4">4x4 Económico</Link>
				</li>
				<li>
					<Link to="/es/fleet/compact_pick_up">Pick up Compacto</Link>
				</li>
				<li>
					<Link to="/es/fleet/full_size">Grande</Link>
				</li>
				<li>
					<Link to="/es/fleet/mini_van">Mini Van</Link>
				</li>
				<li>
					<Link to="/es/fleet/mid_size_sub">Sub Mediana </Link>
				</li>
				<li>
					<Link to="/es/fleet/standard_pick_up">Pick Up Standard</Link>
				</li>
				<li>
					<Link to="/es/fleet/luxury_sub ">Sub De Lujo </Link>
				</li>
				<li>
					<Link to="/es/fleet/standard_van">Van Standard </Link>
				</li>
			
			</ul>
		)
	}
	return (
		<ul className="dropdown locations_menu_fleet">
				<li>
					<Link to="/en/fleet/standard_suv">Standard SUV</Link>
				</li>
				<li>
					<Link to="/en/fleet/compact_recreational_vehicle">Compact Recreational Vehicle</Link>
				</li>
				<li>
					<Link to="/en/fleet/mid_size_pick_up">Mid-size Pick up</Link>
				</li>
				<li>
					<Link to="/en/fleet/standard_elite_suv">Standard Elite SUV</Link>
				</li>
				<li>
					<Link to="/en/fleet/premium">Premium</Link>
				</li>
				<li>
					<Link to="/en/fleet/luxury">Luxury</Link>
				</li>
				<li>
					<Link to="/en/fleet/standard_sport">Standard Sport</Link>
				</li>
				<li>
					<Link to="/en/fleet/premium_elite">Premium Elite</Link>
				</li>
				<li>
					<Link to="/en/fleet/economic">Economic</Link>
				</li>
				<li>
					<Link to="/en/fleet/compact">Compact</Link>
				</li>
				<li>
					<Link to="/en/fleet/economic_4x4">Economic 4x4</Link>
				</li>
				<li>
					<Link to="/en/fleet/compact_pick_up">Compact Pick Up</Link>
				</li>
				<li>
					<Link to="/en/fleet/full_size">Full Size</Link>
				</li>
				<li>
					<Link to="/en/fleet/mini_van">Mini Van</Link>
				</li>
				<li>
					<Link to="/en/fleet/mid_size_sub">Mid Size Sub   </Link>
				</li>
				<li>
					<Link to="/en/fleet/standard_pick_up">Standard Pick Up</Link>
				</li>
				<li>
					<Link to="/en/fleet/luxury_sub ">Luxury Sub </Link>
				</li>
				<li>
					<Link to="/en/fleet/standard_van">Standard Van </Link>
				</li>
			</ul>
	)
}

export default FleetMenu*/



import React, { Component } from 'react'
import Img from 'gatsby-image'
import axios from 'axios'
import Helmet from 'react-helmet'
import { backendURL } from '../data/config.json'
import Link from 'gatsby-link'

class FleetMenuEn extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
    }
    this.handleToogle = this.handleToogle.bind(this)
	this.renderCategoryfleet = this.renderCategoryfleet.bind(this)
	

  }
  componentDidMount() {
    axios.get(`${backendURL}/api/categoryfleets`).then(res => {
      this.setState({
        loading: false,
        categoryfleets: res.data,
      })
      axios
        .get(`${backendURL}/api/banners/page/Faqs`)
        .then(res => {
          const main = res.data.filter(data => data.section === 'Main')
          if (main[0]) {
            this.setState(prevState => {
              return {
                ...prevState,
                loading: false,
                mainImageEs: {
                  title: main[0].title.es,
                  url: main[0].imageEs,
                },
              }
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    })
  }
  handleToogle(e) {
    const { checked: value, id } = e.target
    this.setState({
      [id]: value,
    })
  }
  renderCategoryfleet() {
    const { categoryfleets } = this.state
    return _.map(categoryfleets, (categoryfleet, i) => {
      const { title, description, published } = categoryfleet
     // const { langKey: lang } = this.props.pathContext
      if (published) {
        const id = `categoryfleet${i}`
        return (

		  
			<li>     
               <Link to={description.en}>{title.en}</Link>
			   </li>
            
        )
        return null
      }
    })
  }

 

  render() {

	
    if (this.state.loading) {
      return null
	}
	
	
    return (

		<ul className="dropdown locations_menu_fleet">
		{this.renderCategoryfleet()}
		</ul>
        
	)

  }
}

export const query = graphql`
  query FleetMenuEnQuery {
    imageSharp(id: { regex: "/faq-top-background/" }) {
      sizes(maxWidth: 1600) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`

export default FleetMenuEn



// WEBPACK FOOTER //
// ./src/menus/FleetMenuEn.js